import moment from 'moment';
import angular from 'angular';

class PerDiemRatesController {
  constructor($rootScope, $http, $timeout, toastr) {
    'ngInject';

    this.$rootScope = $rootScope;
    this.$http = $http;
    this.$timeout = $timeout;
    this.toastr = toastr;

    this.baseUrl = $rootScope.apiHost + '/api/admin/per-diem-rates';
    this.sourceType = 'CONUS';
    this.notes = '';
    this.selectedFile = null;
    this.selectedFileName = '';
    this.uploading = false;
    this.loadingImports = true;
    this.imports = [];

    this.search = {
      city: '',
      state: '',
      country: ''
    };
    this.searchResults = [];
    this.searching = false;

    this.loadImports();
  }

  loadImports() {
    this.loadingImports = true;
    this.$http.get(this.baseUrl + '/imports', { withCredentials: true }).then((success) => {
      this.imports = success.data || [];
      this.loadingImports = false;
    }, () => {
      this.loadingImports = false;
      this.toastr.error('Could not load import history.', 'Error');
    });
  }

  onFileSelected(input) {
    const file = input && input.files && input.files[0];
    this.$timeout(() => {
      this.selectedFile = file || null;
      this.selectedFileName = file ? file.name : '';
    });
  }

  upload() {
    if (!this.selectedFile) {
      this.toastr.warning('Select a DoD Excel, CSV, or ASCII rate file to upload.', 'File Required');
      return;
    }
    if (!this.sourceType) {
      this.toastr.warning('Select whether this file is CONUS or OCONUS.', 'Source Required');
      return;
    }

    const formData = new FormData();
    formData.append('file', this.selectedFile);
    formData.append('sourceType', this.sourceType);
    if (this.notes) {
      formData.append('notes', this.notes);
    }

    this.uploading = true;
    this.$http.post(this.baseUrl + '/imports', formData, {
      withCredentials: true,
      headers: { 'Content-Type': undefined },
      transformRequest: angular.identity
    }).then((success) => {
      this.uploading = false;
      const imported = success.data || {};
      this.toastr.success(
        (imported.rowCount || 0) + ' rates imported from ' + (imported.filename || 'file') + '.',
        'Import Complete'
      );
      this.selectedFile = null;
      this.selectedFileName = '';
      this.notes = '';
      const fileInput = document.getElementById('perDiemRateFile');
      if (fileInput) {
        fileInput.value = '';
      }
      this.loadImports();
    }, (error) => {
      this.uploading = false;
      const message = (error.data && (error.data.detail || error.data.message || error.data.error))
        || (error.statusText) || 'Import failed.';
      this.toastr.error(message, 'Import Failed');
      this.loadImports();
    });
  }

  runSearch() {
    const params = {};
    if (this.search.city) {
      params.city = this.search.city;
    }
    if (this.search.state) {
      params.state = this.search.state;
    }
    if (this.search.country) {
      params.country = this.search.country;
    }
    if (!params.city && !params.state && !params.country) {
      this.toastr.warning('Enter a city, state, or country to search.', 'Search Required');
      return;
    }

    this.searching = true;
    this.$http.get(this.baseUrl + '/search', { params, withCredentials: true }).then((success) => {
      this.searchResults = success.data || [];
      this.searching = false;
      if (!this.searchResults.length) {
        this.toastr.info('No matching rates found.', 'Search');
      }
    }, () => {
      this.searching = false;
      this.toastr.error('Rate search failed.', 'Error');
    });
  }

  formatMoney(value) {
    if (value == null || value === '') {
      return '—';
    }
    return '$' + Number(value).toFixed(2);
  }

  formatDateTime(value) {
    if (!value) {
      return '—';
    }
    return moment(value).format('MM/DD/YYYY h:mm A');
  }
}

export default PerDiemRatesController;



// WEBPACK FOOTER //
// ./client/pages/admin/per-diem-rates/per-diem-rates.controller.js